import styled from "styled-components";
import { GoPrimitiveDot } from "react-icons/go";
import { Container } from "../../../components/navbar/Nav.styles";
import { Button } from "../../home/components/HeroSession.js/HeroSession.styles";

const SchoolFee = () => {
  return (
    <ContainerProd>
      <Wrapper>
        <div>
          <div className="web__content">
            <h1>School Fees Advance</h1>
            <p>
              School fees advance Is a loan that offers to finance the payment
              of tuition fees for tertiary institutions only. This product is so
              that you can save up about 50% of your ward’s tuition fee ahead of
              the payment time considering that Private University school fees
              are a bit on the high side.
              <br /> <br />
              Also, for parents who their children are probably still in the
              secondary school and would desire that their wards attend private
              university, so that they can start to save ahead of time.
            </p>
          </div>
          <div>
            <img
              className="first__image"
              style={{ marginTop: "2rem" }}
              src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651636145/invest-trust/Rectangle_49_5_j6o6u2.png"
              alt="betalife"
            />
          </div>

          <h2 className="web__features">Features</h2>
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>Access to loan after 50% savings </span>
          </BenefitItem>

          <div className="start__saving">
            <Button to="/fee">Start Saving</Button>
          </div>
          <div style={{ marginTop: "4rem" }}>
            <img
              className="web__view"
              src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651636146/invest-trust/Rectangle_9123_4_shtvah.png"
              alt="betalife"
            />
          </div>
        </div>
        <BenefitComp>
          <div>
            <div className="mobile__content">
              <h1>School Fees Advance</h1>
              <p>
                School fees advance Is a loan that offers to finance the payment
                of tuition fees for tertiary institutions only. This product is
                so that you can save up about 50% of your ward’s tuition fee
                ahead of the payment time considering that Private University
                school fees are a bit on the high side.
                <br /> <br />
                Also, for parents who their children are probably still in the
                secondary school and would desire that their wards attend
                private university, so that they can start to save ahead of
                time.
              </p>
            </div>
            <div>
              <img
                src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651540953/invest-trust/Rectangle_9119_1_cgs9nl.png"
                alt="betalife"
              />
            </div>
          </div>
          <h2>Benefits</h2>
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>Guaranteed education.</span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point__benefit" />
            <span>It secures the career goal of your child.</span>
          </BenefitItem>
          <br />
          <BenefitItem>
            <GoPrimitiveDot className="bullet__point" />
            <span>It guarantees financial security for your child</span>
          </BenefitItem>
          <div style={{ marginTop: "4rem" }}>
            <img
              className="mobile__view"
              src="https://res.cloudinary.com/dvwbbiu0g/image/upload/v1651636146/invest-trust/Rectangle_9123_4_shtvah.png"
              alt="betalife"
            />
          </div>
        </BenefitComp>
      </Wrapper>
    </ContainerProd>
  );
};

export default SchoolFee;
export const ContainerProd = styled(Container)`
  transform: translateY(-8rem);
  background-color: #dbdbf9;
`;

export const Wrapper = styled.div`
  .web__view {
    display: none;
  }
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 43px;
  margin-bottom: 2rem;

  img {
    max-width: 100%;
  }

  div:nth-of-type(1) {
    // border: 3px solid teal;
  }

  div:nth-of-type(1) h1 {
    font-size: 3rem;
    font-family: "Futura";
    font-size: 3rem;
    font-weight: 200;
  }
  div:nth-of-type(1) p {
    font-size: 20px;
    padding-right: 2.5rem;
    // border: 3px solid red;
  }

  .beta__life {
    color: ${({ theme }) => theme.colors.secondary};
  }
  .start__saving {
    margin-top: 4rem;
  }
  .start__saving a {
    border: 1px solid ${({ theme }) => theme.colors.secondary};
  }
  .bullet__point {
    font-size: 32px;
    color: #1b20e5;
  }
  .bullet__point__benefit {
    font-size: 32px;
    color: #1b20e5;
    margin-top: 0rem;
    margin-left: 0.1rem;
  }
  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    .start__saving {
      display: flex;
      justify-content: center;
    }
    .web__content {
      display: none;
    }
    .web__view {
      display: inline-block;
    }
    div:nth-of-type(1) h1 {
      font-size: 3rem;
      text-align: center;
    }
    .beta__life {
      display: block;
    }
    div:nth-of-type(1) p {
      font-size: 20px;
      padding-right: 0rem;
      text-align: center;
    }
  }
  @media screen and (max-width: 579px) {
    grid-template-columns: 1fr;
    .first__image {
      transform: translateY(-20rem);
    }
    .web__features {
      transform: translateY(-18rem);
      margin-bottom: -18rem;
      //   border: 2px solid red;
    }
    div:nth-of-type(1) h1 {
      font-size: 2rem;
      text-align: center;
      line-height: 40px;
    }
    .bullet__point {
      margin-top: 0.4rem;
      font-size: 16px;
      color: #1b20e5;
    }
    .bullet__point__benefit {
      font-size: 16px;
      color: #1b20e5;
      margin-top: 0.4rem;
      margin-left: 0.1rem;
    }
  }
`;

export const BenefitComp = styled.div`
  .mobile__content {
    display: none;
  }
  .mobile__view {
    display: inline-block;
  }
  margin-bottom: 15rem;
  div: nth-of-type(2);
  @media screen and (max-width: 991px) {
    grid-row-start: 1;
    grid-row-end: 3;
    .mobile__content {
      display: block;
    }
    .mobile__view {
      display: none;
    }
  }
  @media screen and (max-width: 579px) {
  }
`;

export const BenefitItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  // width: 577px;

  .product__dot {
    color: ${({ theme }) => theme.colors.secondary};
    background-color: ${({ theme }) => theme.colors.secondary};
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
  }
  span {
    font-size: 20px;
  }
  @media screen and (max-width: 991px) {
  }
  @media screen and (max-width: 579px) {
    align-items: flex-start;
    margin-left: 1rem;
    margin-right: 1rem;
  }
  span {
    font-size: 20px;
    padding-right: 2rem;
  }
`;
